<template>
  <v-card class="card--shadow">
    <v-card-title>Visit Date</v-card-title>
    <v-card-text>
      <date-generate-from @generateDate="generateDate" />
    </v-card-text>
    <v-card-text>
      <div v-if="this.dates.length>0" class="color-box-row mb-2">
      <div class="color-box-container">
          <div class="color-box" style="background-color: blue;"></div>
          <span>In Person</span>&nbsp;
        </div>  

      <div class="color-box-container">
        <div class="color-box" style="background-color: #1E90FF;"></div>
        <span>By Phone</span>&nbsp;
      </div>

      <div class="color-box-container">
        <div class="color-box" style="background-color: #24b014;"></div>
        <span>INNO DOT</span>&nbsp;
      </div>

      <div class="color-box-container">
        <div class="color-box" style="background-color: red;"></div>
        <span>Cannot call</span>&nbsp;
      </div>

      </div>
      <date-table-view :dates="dates" />
    </v-card-text>
  </v-card>
</template>

<script>
import DateGenerateFrom from "./UseApp/DateGenerateForm.vue";
import DateTableView from "./UseApp/DateTableView.vue";
import { generateDate } from "./helper";

export default {
  data: () => ({
    dates: [],
  }),
  components: {
    DateGenerateFrom,
    DateTableView,
  },
  methods: {
    generateDate(data) {
      this.$store
        .dispatch("DotsPatient/getVisitDate", {
          dots_patient_id: this.$route.params.id,
          start_date: data.startDate,
          end_date: data.endDate,
        })
        .then((res) => {
          this.dates = generateDate(data.startDate, data.endDate);
          if (Array.isArray(res) && res.length > 0) {
            this.dates = this.generateResult(this.dates, res);
          }
          console.log(this.dates);
        });
    },
    generateResult(dates, res) {
      dates = dates.map((date) => {
        res.forEach((foundDate) => {
          if (foundDate.date == date.date) {
            date.found = true;
            date.data = foundDate;
          }
        });
        return date;
      });

      return dates;
    },
  },
};
</script>

<style>
  /* legend */
  .color-box-container {
    display: flex;
    align-items: center;
  }

  .color-box-row {
    display: flex;
  }


  .color-box {
    width: 16px; 
    height: 16px;
    border-radius: 3px;
    margin-right: 2px; 
    
    border: 1px solid #000; 
  }

  .color-box-container span {
    font-size: 14px; 
    color: #333;
  }

</style>